import { EstadosFacturacion } from "src/constants/stripe"
import { useEstadoSuscripcionHotelQuery } from "src/gql/schema"
import { DateTime } from "luxon"
import { useProfile } from "./useProfile"

const getStringDate = (date: any) => {
    if (!date) return null

    const d = typeof date === "number" ? DateTime.fromMillis(date).toJSDate() : DateTime.fromISO(date).toJSDate()

    if (isNaN(d.getTime())) return null

    return `${`${d.getDate()}`.padStart(2, "0")}/${`${d.getMonth() + 1}`.padStart(2, "0")}/${d.getFullYear()}`
}

export function useEstadoSuscripcion() {
    const { hotel_id } = useProfile()
    const { data } = useEstadoSuscripcionHotelQuery({ variables: { hotel_id } })
    const estado = data?.estadoSuscripcionHotel

    const fecha = 
        estado && 
        estado.estado_facturacion === EstadosFacturacion.PastDue &&
        estado.fecha_fin_gracia > 0
        ? getStringDate(estado.fecha_fin_gracia) 
        : null
    
    return {
        fecha_pago_pendiente: fecha
    }
}